module.exports = __webpack_public_path__ + "assets/img/888SPORT.f527bc67.png";